import LocalLanding from "./LocalLanding";
export default function LandingSantarem() {
    return (
        <LocalLanding
            city="Distrito de Santarém"
            canonicalSlug="remodelacoes-santarem"
            hero="https://plus.unsplash.com/premium_photo-1733317226940-b7b0fe585b83?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
        />
    );
}
